import React, { useEffect } from "react";

import { Button, Form, Input } from "antd";
import type { FormInstance } from "antd";

import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";

import { MailOutlined } from "@ant-design/icons";
import { RestorePasswordFormProps, RestorePasswordFormInputModel } from "./types";

import { makeSelectRestorePasswordFormErrors } from "../../../../selectors";

function RestorePasswordForm({ loadingData, onRestorePassword }: RestorePasswordFormProps) {
  const { t } = useTranslation("translations");

  const [form] = Form.useForm<RestorePasswordFormInputModel>();

  const formErrors = useSelector(makeSelectRestorePasswordFormErrors());

  useEffect(() => {
    if (formErrors) {
      const errors: Parameters<FormInstance["setFields"]>[0] = [];

      if (formErrors.find((x) => x.field === "email" && x.errorCode === "2")) {
        errors.push({
          name: "login",
          errors: [t("identification_number_already_registered")],
        });
      }

      form.setFields(errors);
    }
  }, [formErrors, form, t]);

  const onFinish = ({ email }: RestorePasswordFormInputModel) => {
    onRestorePassword({ email });
  };

  return (
    <Form<RestorePasswordFormInputModel> onFinish={onFinish} form={form} layout="vertical" requiredMark={false} preserve={false}>
      <Form.Item
        name="email"
        label="Email"
        rules={[
          { required: true, message: t("enter_email")! },
          { type: "email", message: t("wrong_email")! },
        ]}
      >
        <Input prefix={<MailOutlined aria-hidden />} type="email" autoComplete="email" aria-label="Email" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" block loading={loadingData}>
          {t("send")}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default React.memo(RestorePasswordForm);
